import React, { FC } from 'react';
import { Tooltip } from '@mui/material';
import { trackingSourcesMap } from '../components/staticCard/StaticCard';
import { TrackingSourceEnum } from '../components/enums/trackingSourceEnum';

interface AdNameCellProps {
  params: number;
  rowObject: any;
}

const AdNameCell: FC<AdNameCellProps> = (props) => {
  const trackingSourceId = props.rowObject?.trackingSourceId;
  const isPinMeTo = trackingSourceId === TrackingSourceEnum.PinMeTo;

  return (
    <div className="flex w-full items-center justify-between gap-2">
      <Tooltip
        arrow
        placement="top"
        title={props.params}
      >
        <div className="flex max-w-[150px] flex-col items-start text-left 2xl:max-w-[150px]">
          <div className="w-[150px] truncate font-semibold 2xl:w-[150px]">
            {props.params}
          </div>
          <div className="w-[150px] truncate 2xl:w-[150px]">
            {props.rowObject?.adId}
          </div>
        </div>
      </Tooltip>
      <div className={isPinMeTo ? 'h-5 w-5' : 'h-3.5 w-3.5'}>
        {trackingSourcesMap?.[trackingSourceId]?.iconPrimary && (
          <img
            src={trackingSourcesMap[trackingSourceId].iconPrimary}
            alt={trackingSourcesMap[trackingSourceId].name}
            className="block h-full w-full object-contain"
          />
        )}
      </div>
    </div>
  );
};

export default AdNameCell;
